<template>
	<app>
		<c-form ref="form">
			<c-form-item v-model="inputCode" type="input" label="项目邀请码" required @change="getProjectInfo"></c-form-item>
			<c-form-item type="input" label="项目名称" name="name" required disabled></c-form-item>
			<c-form-item type="input" label="中标单位" name="zbqy_name" required disabled></c-form-item>
		</c-form>
		
		<div slot="button">
			<c-button size="m" @click="submitHandle">确定加入</c-button>
		</div>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		data() {
			return {
				inputCode: '',
				inviteCode: ''
			}
		},
		
		methods: {
			getProjectInfo() {
				if (this.inputCode) {
					this.request({
						url: '/project/queryByCode',
						data: {
							yq_code: this.inputCode
						},
						success: data => {
							this.inviteCode = this.inputCode;
							this.$refs.form.set(data);
						},
						fail: () => {
							this.inviteCode = '';
							this.$refs.form.clear();
						}
					});
				} else {
					this.inviteCode = '';
					this.$refs.form.clear();
				}
			},
			
			submitHandle() {
				if (!this.inviteCode) {
					this.$message({
						text: '请填写项目邀请码'
					});
					return;
				}
				
				this.request({
					url: '/project/bind_jl',
					data: {
						yq_code: this.inviteCode
					},
					loading: true,
					success: data => {
						this.$message({
							text: '添加成功'
						});
						this.navigateBack();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
